import { Linking, Platform } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { LOCATION_MODE } from '@/types/location-mode';

interface Locatable {
  address?: string | null;
  locationMode?: LOCATION_MODE | null;
  meetingUrl?: string | null;
}

export interface AppointmentLocation {
  mode: LOCATION_MODE | null;
  icon: keyof typeof Ionicons.glyphMap;
  label: string;
  /** Presente só quando dá para abrir no mapa. */
  address: string | null;
  /** Link da chamada (online), quando o prestador já enviou. */
  meetingUrl: string | null;
}

/**
 * Onde o encontro acontece, do ponto de vista do cliente. Serviço antigo sem
 * modo cai no endereço: com endereço é espaço do prestador, sem ele não há o
 * que dizer (nulo).
 */
export function resolveAppointmentLocation(item: Locatable): AppointmentLocation | null {
  const address = item.address?.trim() || null;
  const mode = item.locationMode ?? (address ? LOCATION_MODE.PROVIDER_SPACE : null);
  const meetingUrl = item.meetingUrl?.trim() || null;

  switch (mode) {
    case LOCATION_MODE.PROVIDER_SPACE:
      return address
        ? { mode, icon: 'location-outline', label: address, address, meetingUrl: null }
        : {
            mode,
            icon: 'location-outline',
            label: 'Endereço com o profissional',
            address: null,
            meetingUrl: null,
          };
    case LOCATION_MODE.CLIENT_ADDRESS:
      // Aqui `address` é o do cliente, informado ao marcar.
      return address
        ? { mode, icon: 'home-outline', label: address, address, meetingUrl: null }
        : { mode, icon: 'home-outline', label: 'No seu endereço', address: null, meetingUrl: null };
    case LOCATION_MODE.ONLINE:
      return {
        mode,
        icon: 'videocam-outline',
        label: meetingUrl ? 'Atendimento online · link enviado' : 'Atendimento online',
        address: null,
        meetingUrl,
      };
    default:
      return null;
  }
}

/** Abre o endereço no app de mapas do aparelho (Apple Maps no iOS, Google no resto). */
export function openAddressInMaps(address: string) {
  const query = encodeURIComponent(address);
  const url =
    Platform.OS === 'ios'
      ? `http://maps.apple.com/?q=${query}`
      : `https://www.google.com/maps/search/?api=1&query=${query}`;
  void Linking.openURL(url);
}

/** Abre o link da chamada (Meet, Zoom, WhatsApp...) no app que o aparelho escolher. */
export function openMeetingUrl(url: string) {
  void Linking.openURL(url);
}
